import React, { Component } from 'react';
import './FormInput.css';

class FormInput extends Component {
  render() {
    let id = Math.random().toString(36).substr(2, 5);
    let type = this.props.type;
    let errorMessageIsSet = typeof this.props.errorMessage !== 'undefined';
    let labelIsSet = typeof this.props.label !== 'undefined';
    let onLabelClick = function (el) {
      switch (type) {
        case 'input':
        case 'password':
          return function() {document.getElementById(el).focus()};
        case 'checkbox':
          return function() {document.getElementById(el).click()};
        default:
          break;
      }
    };
    return (
      <div className = {'FormInput ' + type}>
        <input id = {id} type = {type} placeholder = {this.props.placeholder} value = {this.props.value} onChange = {this.props.onChange}/>
        { errorMessageIsSet &&
          <div className = "FormInputErrorMessage">{this.props.errorMessage}</div>
        }
        { labelIsSet &&
          <label className = "FormInputLabel" onClick={onLabelClick(id)} >{this.props.label}</label>
        }
      </div>
    );
  }
}

export default FormInput;
